import { MapboxLocationMapper } from '@/modules/ta/legacy/widget/services/types/MapboxAutoZoomService';
import { MapboxLayerService } from '@/modules/ta/legacy/widget/services/types/MapboxLayerService';
import { CITY } from '@/modules/ta/legacy/widget/mapbox.constants';

export class MapboxCityLayerService extends MapboxLayerService {
  constructor(widget) {
    super(widget, CITY);
  }

  getData(data = []) {
    return data
      .filter((row) => row.geocode1 && this.USCountryFilter(row))
      .map((row) => {
        const stateCode = MapboxLocationMapper.normalizeState(
          row.geocode1?.split('-')[1]?.toUpperCase()
        );
        const city = this.getName(row, this.groupedColumn.field);
        return {
          state: stateCode,
          city,
          value: parseInt(String(row[this.column.field]).replace(/,/g, ''), 10),
        };
      });
  }

  filterData(data) {
    return data;
  }

  getName(rowData, field) {
    const details = rowData[field]?.split('-');
    return details?.[details.length - 1] || 'unknown';
  }

  getFilters(data) {
    let groupedData = data.reduce((acc, item) => {
      if (!acc[item.state]) {
        acc[item.state] = [];
      }
      acc[item.state].push(item);
      return acc;
    }, {});
    const filterNames = this.getConfig('FIELDS');
    return [
      'any',
      ...Object.entries(groupedData).map(([state, cities]) => [
        'all',
        ['==', 'STUSPS', state],
        ['any', ...filterNames.map((field) => ['in', field, ...cities.map((city) => city.city)])],
      ]),
    ];
  }
}
